import { get } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config'; // Import the helper function
import { MEDICARE_SEARCH } from '../constants/medicare-search';

const apiNamePath = PRESCRIPTSURE.MEDICARE_API; // API endpoint from constants

const medicareApiService = {
  async zipCodeFuzzySearch(searchTerm) {
    try {
      const sessionToken = await getSessionToken();

      const zipCodeFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/medicare_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: MEDICARE_SEARCH.ZIP_CODE.search_type,
            search_term: searchTerm,
          },
        },
      });

      const zipCodeFuzzySearchResults = (
        await zipCodeFuzzySearchOperation.response
      ).body.json();

      return zipCodeFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching medicare plan information:', error);
    }
  },

  async medicareProviderFuzzySearch(searchTerm, countyCode) {
    try {
      const sessionToken = await getSessionToken();

      const medicareProviderFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/medicare_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: MEDICARE_SEARCH.PROVIDER.search_type,
            search_term: searchTerm,
            county_code: countyCode,
          },
        },
      });

      const medicareProviderFuzzySearchResults = (
        await medicareProviderFuzzySearchOperation.response
      ).body.json();

      return medicareProviderFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching medicare plan information:', error);
    }
  },

  async medicarePlanFuzzySearch(searchTerm, countyCode, compositeName) {
    try {
      const sessionToken = await getSessionToken();

      const medicarePlanFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/medicare_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: MEDICARE_SEARCH.PLAN.search_type,
            search_term: searchTerm,
            county_code: countyCode,
            composite_name: compositeName,
          },
        },
      });

      const medicarePlanFuzzySearchResults = (
        await medicarePlanFuzzySearchOperation.response
      ).body.json();

      return medicarePlanFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching medicare plan information:', error);
    }
  },

  async medicareDrugFuzzySearch(searchTerm, formularyId) {
    try {
      const sessionToken = await getSessionToken();

      const medicareDrugFuzzySearchOperation = get({
        apiName: apiNamePath,
        path: `/medicare_fuzzy_search`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            search_type: MEDICARE_SEARCH.DRUG.search_type,
            search_term: searchTerm,
            formulary_id: formularyId,
          },
        },
      });

      const medicareDrugFuzzySearchResults = (
        await medicareDrugFuzzySearchOperation.response
      ).body.json();

      return medicareDrugFuzzySearchResults;
    } catch (error) {
      console.error('Error fetching medicare plan information:', error);
    }
  },

  async getMedicarePlanInfo(planId, contractId, countyCode, drugTier) {
    try {
      const sessionToken = await getSessionToken();
      const medicarePlanInfoOperation = get({
        apiName: apiNamePath,
        path: `/medicare_plan_info`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            plan_id: encodeURI(planId),
            contract_id: encodeURI(contractId),
            county_code: encodeURI(countyCode),
            drug_tier: encodeURI(drugTier),
          },
        },
      });

      const medicarePlanInfo = (
        await medicarePlanInfoOperation.response
      ).body.json();

      return medicarePlanInfo;
    } catch (error) {
      console.error('Error fetching medicare plan information:', error);
    }
  },

  async getMedicareDrugInfo(formularyId, rxcui) {
    try {
      const sessionToken = await getSessionToken();
      const medicareDrugInfoOperation = get({
        apiName: apiNamePath,
        path: `/medicare_get_drug_info`,
        options: {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
          },
          queryParams: {
            formulary_id: encodeURI(formularyId),
            rxcui: encodeURI(rxcui),
          },
        },
      });

      const medicareDrugInfo = (
        await medicareDrugInfoOperation.response
      ).body.json();

      return medicareDrugInfo;
    } catch (error) {
      console.error('Error fetching medicare drug information:', error);
    }
  },
};

export default medicareApiService;
